import { render, staticRenderFns } from "./DeletarMenu.vue?vue&type=template&id=76ebda4e"
import script from "./DeletarMenu.vue?vue&type=script&lang=js"
export * from "./DeletarMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports